import React from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import SimpleRadioButtonGroup from './SimpleRadioButtonGroup';

export default function RadioButtonGroup({
  name,
  onChange,
  value,
  ...radioButtonGroupProps
}) {
  const { formFieldErrors, formFieldValue, handleFormFieldChange } =
    useFormContext(name);

  return (
    <SimpleRadioButtonGroup
      errors={formFieldErrors}
      name={name}
      onChange={onChange || handleFormFieldChange}
      value={value || formFieldValue}
      {...radioButtonGroupProps}
    />
  );
}

RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string
};

RadioButtonGroup.defaultProps = {
  onChange: null,
  value: null
};
